import PropTypes from 'prop-types';
import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { ButtonTrading } from './styled';

const { Flex, Iconmoon, IconWrapper, Text } = Common;

const virtualAreaImg =
  'data:image/svg+xml;base64,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';

const ButtonTradingOutline = ({
  isActive,
  minimize,
  label,
  imageSrc,
  onChangeVisibility,
  ...otherProps
}) => (
  <ButtonTrading
    isActive={isActive}
    minimize={minimize}
    onClick={() => onChangeVisibility(!isActive)}
    {...otherProps}
  >
    <IconWrapper size="50px">
      <Image
        src={label === 'Virtual Area' ? virtualAreaImg : imageSrc}
        alt=""
        style={{ width: '100%' }}
      />
    </IconWrapper>
    <Flex align="space-between">
      <Text size="13px">{label}</Text>
      <IconWrapper size="16px">
        <Iconmoon className="icon-toolbar_down" />
      </IconWrapper>
    </Flex>
  </ButtonTrading>
);

ButtonTradingOutline.propTypes = {
  isActive: PropTypes.bool.isRequired,
  minimize: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  onChangeVisibility: PropTypes.func.isRequired,
};

export default ButtonTradingOutline;
